import './SearchBar.scss';

import React, { KeyboardEvent, useRef } from 'react';

interface IProps {
  placeholder?: string;
  onSearch?: (term: string) => void;
}

function SearchBar({ placeholder, onSearch }: IProps) {
  const inputRef = useRef<HTMLInputElement>();

  const handleEnterKey = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleOnSearch();
    }
  };

  const handleOnSearch = () => {
    const value = inputRef.current?.value;
    if (value) {
      onSearch?.(value);
      inputRef.current.value = '';
      inputRef.current.blur();
    }
  };

  return (
    <div className="modSearchBar" onClick={() => inputRef.current?.focus()}>
      <input
        ref={inputRef}
        className="modSearchBar__input"
        type="text"
        placeholder={placeholder}
        onKeyUp={handleEnterKey}
      />
      <button className="modSearchBar__button" onClick={handleOnSearch}>
        <i className="modIcon modIcon--magnifier" />
      </button>
    </div>
  );
}

export default SearchBar;
